// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const MinusIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M6 12c0-.552.474-1 1.059-1h9.882c.585 0 1.059.448 1.059 1s-.474 1-1.059 1H7.06C6.474 13 6 12.552 6 12z"/></svg>'} />;

MinusIcon.displayName = 'MinusIcon';

export default MinusIcon;
